@if (success) {
    <div class="swal2-icon swal2-success swal2-animate-success-icon" style="display: flex;">
     <div class="swal2-success-circular-line-left" style="background-color: transparent;"></div>
       <span class="swal2-success-line-tip"></span>
       <span class="swal2-success-line-long"></span>
       <div class="swal2-success-ring"></div> 
       <div class="swal2-success-fix" style="background-color: transparent;"></div>
       <div class="swal2-success-circular-line-right" style="background-color: transparent;"></div>
      </div>
} @else {
    <div class="swal2-icon swal2-error swal2-animate-error-icon" style="display: flex;">
      <span class="swal2-x-mark">
          <span class="swal2-x-mark-line-left"></span>
          <span class="swal2-x-mark-line-right"></span>
      </span>
    </div>
}